import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "Tool",
    serverType: "tool",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "Tool",
            title: ""
        };
    },
    checkContent(content) {
        if (!content.toolId || content.toolId == "def") {
            throw new ParamError(i18n.t("zhiji.answer.selectToolsType"));
        }
    },
    server2Client(content) {
        return {
            uId: uniqueId(),
            wtType: "Tool",
            title: "",
            toolId: content.api_index,
            updateState: "add",
            toolName: content.name
        };
    },
    client2Server(content) {
        return {
            type: "tool",
            api_index: content.toolId,
            name: content.toolName,
            card_image: "",
            tool_id: "1",
            tool_desc: "可查询7天内数据",
            time_period: "7",
            error_msg: "你的道具记录最近7天没有变化的信息哦~传闻拥有道具越多的人越强噢"
        };
    }
};
